import {
  CAN_MANAGE_LOCATIONS,
  CAN_MANAGE_LOCAL_POSTS,
} from "@/constants/permissions";
import isNotEmpty from '@/helpers/isNotEmpty'

export default (permissions) => {
  if (!isNotEmpty(permissions)) {
    return true
  }
  permissions = Array.isArray(permissions) ? permissions : [permissions]
  try {
    if (!permissions) return true
    const userPermissions = JSON.parse(localStorage.getItem('permissions'))
    if (!userPermissions) return false

    let has
    for(const p in permissions) {
      has = userPermissions.find(up => up.name === permissions[p])
      if (has) break
    }
    
    if(has.name === CAN_MANAGE_LOCATIONS) {
      const canUserManagePosts = userPermissions.some(
        permission => permission.name === CAN_MANAGE_LOCAL_POSTS
      )
      return canUserManagePosts ? true : false
    }

    return !!has
  } catch (e) {
    return false
  }
}